import React, { Component } from 'react';
import Slider from 'react-slick';
import { Header } from './layout/Header';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';


const images = [
  'https://via.placeholder.com/600X750/444444.jpg',
  'https://via.placeholder.com/600X750/444444.jpg',
  'https://via.placeholder.com/600X750/444444.jpg',
  'https://via.placeholder.com/600X750/444444.jpg',
  'https://via.placeholder.com/600X750/444444.jpg'
];

export class Home extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }
  render() {
    var slick_slider = {
      dots: false,
      arrow: false,
      autoplay: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 4,
      slidesToScroll: 1,
      rows: 1,

      responsive: [{
  
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    },
    {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
    };
      var slick_slider_ltr = {
      infinite: true,
      arrows: false,
      dots: false,                   
      autoplay: true,
      centerMode : false,
      autoplaySpeed: 0,
      speed: 9000,
      cssEase: "linear",
      pauseOnHover: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      }

      var slick_slider_rtl = {
      infinite: true,
      arrows: false,
      dots: false,                   
      autoplay: true,
      centerMode : false,
      rtl: true,
      autoplaySpeed: 0,
      speed: 9000,
      cssEase: "linear",
      pauseOnHover: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      };
        
        return (       
          <div className="site-main">   
            <Header/> 

            <section className="ttm-row banner-section ttm-textcolor-white ttm-bg ttm-bgimage-yes bg-img4 overflow-hidden clearfix">
                <div class="ttm-row-wrapper-bg-layer ttm-bg-layer"></div>
                <div class="bg-image-overlay"></div>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-11 text-center m-auto">
                      <div class="section-title style4">
                        <div className="title-header">
                          <h2 class="title">Build your </h2>
                          <div class="banner-text">
                            <div class="w-layout-grid grid-24">
                              <p class="text-right pt-60 res-1400-text-center">Our vast experience, thought leadership<br /> and commitment to digitization invetion</p>
                              <h2 class="title position-relative right_20"><div className="ttm-textcolor-skincolor d-inline-block">team</div> the </h2>
                            </div>
                          </div>
                          <h2 class="title"> easy way </h2>
                        </div>
                      </div>
                      <div class="banner-buttons text-center res-991-mb-0 res-575-mt-0 res-575-mb-0 mt-50 mb-40">
                          <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-gradiant mr-20 mb-20 res-991-mb-10 d-inline-block" href={process.env.PUBLIC_URL + '/Contact_01'}>start free trail!</a>
                          <p className=" d-inline-block text-left">High degree of the sensitivity and specificity <br /> to prescribe recommended actions</p>
                      </div>
                    </div>
                  </div>
                </div>
            </section>
            
            {/* aboutus-section */}
            <section class="ttm-row services-section clearfix">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                            <div class="section-title res-991-mb-0">
                                <div class="title-header">
                                    <h2 class="title">Giving your business some orignal ideas</h2>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12"> 
                            <div class="process-desc pl-90 res-1199-pl-0 pt-10">
                                <p class="desc-text">We strive to deliver best in-class software solutions that generate best trailing total return for business services across great mission goals generating billion net income</p>
                            </div>
                        </div>
                    </div>
                    <div class="row row-equal-height">
                        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div class="featured-icon-box style1 first-child">
                                <div class="featured-icon-thumnail">
                                    <img src="images/icon-01.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" />
                                </div>
                                <div class="featured-content">
                                  <h3 class="featured-title-h3">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">UI/UX creative<br /> design</a>
                                  </h3>
                                  <div class="featured-bottom-btn">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div class="featured-icon-box style1 border-none">
                                <div class="featured-icon-thumnail">
                                    <img src="images/icon-02.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" /></div>
                                <div class="featured-content">
                                  <h3 class="featured-title-h3">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">Visual &amp; graphic design</a>
                                  </h3>
                                  <div class="featured-bottom-btn">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div class="featured-icon-box style1 res-991-pl-0">
                                <div class="featured-icon-thumnail"><img src="images/icon-03.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" /></div>
                                <div class="featured-content">
                                  <h3 class="featured-title-h3">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">Digital marketing<br />strategy</a>
                                  </h3>
                                  <div class="featured-bottom-btn">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div class="featured-icon-box style1 last-child">
                                <div class="featured-icon-thumnail">
                                    <img src="images/icon-04.png" loading="lazy" alt="Icon" class="rotate-img img-fluid" />
                                </div>
                                <div class="featured-content">
                                  <h3 class="featured-title-h3">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="featured-title-h3-link">Effective customer<br />support</a>
                                  </h3>
                                  <div class="featured-bottom-btn">
                                  <a href={process.env.PUBLIC_URL + '/content_engineering'} class="btn btn-inline"><i class="fas fa-long-arrow-alt-up"></i></a>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* aboutus-section end */}

            <section class="ttm-row zero-padding-section ttm-bg z-index-0 clearfix res-991-pt-0">
                <div class="ttm-row-wrapper-bg-layer ttm-bg-layer spacing-1"></div> 
                <div class="container">
                    <div class="row no-gutters">
                        <div class="col-xl-6 col-lg-6">
                            <div class="ttm-bg ttm-col-bgimage-yes col-bg-img-one ttm-left-span">
                                <div class="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                                <div class="layer-content">
                                </div>
                            </div>
                            <img class="img-fluid ttm-equal-height-image w-100 position-relative" src="images/bg-image/col-bgimage-1.jpg" alt="bg-image" />
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div class="ttm-bgcolor-grey position-relative ttm-right-span spacing-1">
                                <div class="ttm-col-wrapper-bg-layer ttm-bg-layer">
                                    <div class="ttm-col-wrapper-bg-layer-inner"></div>
                                </div>
                                <div class="layer-content">
                                    <div class="position-relative">
                                        <div class="section-title with-desc clearfix">
                                            <div class="title-header">
                                              <h2 className="title">We deal with the aspects IT Services</h2>
                                            </div>
                                            <div class="title-desc">
                                              <p>Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry, to developing high-grade app and manage quality at the top positions standard.</p>
                                            </div>
                                        </div>
                                        <div class="row row-equal-height mt-40">
                                            <div class="col-lg-6">
                                                <div class="featured-box-main">
                                                  <h3 class="featured-box-h3">Seize opportunities and spark</h3>
                                                  <div class="ttm-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-d-none res-991-mt-15"></div>
                                                  <h3 class="featured-box-h3">Experience to share goals success</h3>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="featured-box-main">
                                                    <h3 class="featured-box-h3">Comprehensive test approach</h3>
                                                    <div class="ttm-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-d-none res-991-mt-15"></div>
                                                    <h3 class="featured-box-h3">Innovate create great solutions.</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ttm-row first-row-title-section ttm-textcolor-white ttm-bg ttm-bgimage-yes bg-img1 clearfix">
                <div class="ttm-row-wrapper-bg-layer ttm-bg-layer ttm-bgcolor-darkgrey"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-2 col-md-12">
                            <div class="position-relative">
                                <h2 class="row-heading-h3 res-991-pt-0">One <br />Platform</h2>
                            </div>
                        </div>
                        <div class="col-lg-10 col-md-12">
                            <div class="position-relative res-991-mt-20 res-991-pb-0 pb-25">
                                <h2 class="row-heading-h2">Endlesso</h2>
                                <h2 class="row-heading-h2 pl-155 res-1199-pl-0"><span class="ttm-textcolor-skincolor">oportunities</span></h2>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-50 res-991-mt-20">
                        <div class="col-lg-6 col-md-6">
                            <div class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-01-654x490.png" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">IT consultancy</a>
                                  </h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-05-654x490.jpg" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">Product design</a>
                                  </h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-02-654x490.jpg" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">Cloud computing</a>
                                  </h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-06-654x490.jpg" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">Big data analytics</a>
                                  </h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-03-654x490.jpg" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">IT management</a>
                                  </h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-07-654x490.png" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">Cloud services</a>
                                  </h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-04-654x490.png" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">Main app data</a>
                                  </h3>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div  class="service-box style1">
                                <div class="service-box-thumnail">
                                  <a href={process.env.PUBLIC_URL + '/project_details'}>
                                    <img width="654" height="490" class="img-fluid" src="images/service-08-654x490.png" alt="image" />
                                  </a>
                                </div>
                                <div class="service-box-content">
                                  <h3 class="service-box-h3">
                                  <a href={process.env.PUBLIC_URL + '/project_details'} class="service-box-link">Digital services</a>
                                  </h3>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ttm-row step-section-1 clearfix">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12">
                            <div class="section-title style2">
                                <div class="title-header">
                                  <h2>Our work</h2>
                                  <h2 class="pl-150 res-1199-pl-0 pb-65 res-991-pb-0">process</h2>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 "> 
                            <div class="process-desc">
                                <p class="desc-text">Well aware of the existing mobile app market trends to keep tabs on the evolving trend of the industry, to developing high-grade app and manage quality at the top positions standard.</p>
                                <div class="mt-35 res-991-mt-15">
                                    <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-gradiant" href={process.env.PUBLIC_URL + '/Services_01'}> Learning Working Process</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="ttm-horizontal_sep mt-85 mb-40 res-991-mt-40"></div>
                            <div class="ttm-processbox-wrapper">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <div class="ttm-box-content">
                                            <div class="ttm-hovertext1">
                                                <div class="process-num">
                                                    <div class="numbers">Step 1</div>
                                                </div>
                                            </div>
                                            <div class="ttm-hovertext2">
                                                <div class="process-num">
                                                    <div class="numbers">Step 1</div>
                                                </div>
                                            </div>
                                            <div class="ttm-box-content-title res-991-pt-0">
                                                <h3 class="ttm-box-title-h3">Create</h3>
                                                <p>Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-9">
                                        <div class="ttm-box-image res-991-mt-15">
                                            <img width="965" height="240" class="proces-img img-fluid" src="images/step01.png" loading="lazy" alt="images" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="ttm-horizontal_sep mt-25 mb-40"></div>
                            <div class="ttm-processbox-wrapper">
                                <div class="row">
                                    <div class="col-lg-9">
                                        <div class="ttm-box-image res-991-pb-30">
                                            <img width="965" height="240" class="proces-img img-fluid" src="images/step02.png" loading="lazy" alt="images" />
                                        </div>
                                    </div>
                                    <div class="col-lg-3">
                                        <div class="ttm-box-content res-991-mt-15">
                                            <div class="ttm-hovertext1">
                                                <div class="process-num">
                                                    <div class="numbers">Step 2</div>
                                                </div>
                                            </div>
                                            <div class="ttm-hovertext2">
                                                <div class="process-num">
                                                    <div class="numbers">Step 2</div>
                                                </div>
                                            </div>
                                            <div class="ttm-box-content-title res-991-pt-0">
                                                <h3 class="ttm-box-title-h3">Engage</h3>
                                                <p>Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="ttm-horizontal_sep mt-25 mb-40 res-991-mt-0 res-991-mb-35"></div>
                            <div class="ttm-processbox-wrapper">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <div class="ttm-box-content">
                                            <div class="ttm-hovertext1">
                                                <div class="process-num">
                                                    <div class="numbers">Step 3</div>
                                                </div>
                                            </div>
                                            <div class="ttm-hovertext2">
                                                <div class="process-num">
                                                    <div class="numbers">Step 3</div>
                                                </div>
                                            </div>
                                            <div class="ttm-box-content-title res-991-pt-0">
                                                <h3 class="ttm-box-title-h3">Analyze</h3>
                                                <p>Web designing in a powerful way of just not a profession, hony. We have a tendency to beve.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-9">
                                        <div class="ttm-box-image res-991-mt-15">
                                            <img width="965" height="240" class="proces-img img-fluid" src="images/single-img-13.png" loading="lazy" alt="images" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ttm-row bg-img2 ttm-bgimage-yes ttm-bg bg-base-dark testimonial-section clearfix">
                <div class="ttm-row-wrapper-bg-layer ttm-bg-layer bg-base-dark"></div>
                <div class="container-fluid">
                    <div class="row align-items-center spacing-2">
                      <div class="col-lg-3">
                          <div class="pr-20 res-1199-pr-0">
                              <div class="ttm-custom-counter-content">
                                <h3 class="ttm-custom-heading counter is-visible">15000+</h3>
                                <h3 class="custom-heading-h3">Happy freelancers &amp; agencies</h3>
                              </div>
                              <div class="ttm-custom-counter-desc">
                                <p class="counter-desc-p">Our satisfied customers have the best words for our templates</p>
                              </div>
                          </div>
                      </div>
                      <div class="col-lg-9 res-991-mt-20">
                        <Slider className="row slick_slider slick-arrows-style4" {...slick_slider} slidesToShow={3}arrows={false}
                            autoplay={false} responsive= { [{ breakpoint: 1199, settings: {slidesToShow: 2,slidesToScroll: 2 }},
                            {breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 }} ,
                            {breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 }}] }>
                            <div className="col-lg-12">
                              <div class="testimonials-style1">
                                  <div class="testimonials-style1-content">
                                    <div class="testimonial-ttm-description">
                                      <div class="ttm-box-highlight">
                                        <h3 class="ttm-box-highlight-h3">Fast Support</h3>
                                      </div>
                                      <div class="ttm-ratting-stars">
                                        <ul class="ratting-stars">
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="testimonial-ttm-box-desc">
                                      <p class="testimonial-ttm-box-desc-p">Our team discussed every single detail to make sure Creatives Planet is the
                                      most versatile and unique template created so far. No coding skills.</p>
                                    </div>
                                    <div class="ttm-box-footer">
                                      <h3 class="testimonial-caption-h3">Leon Mayer</h3>
                                    </div>
                                  </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div class="testimonials-style1">
                                  <div class="testimonials-style1-content">
                                    <div class="testimonial-ttm-description">
                                      <div class="ttm-box-highlight">
                                        <h3 class="ttm-box-highlight-h3">Flexible Theme</h3>
                                      </div>
                                      <div class="ttm-ratting-stars">
                                        <ul class="ratting-stars">
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="testimonial-ttm-box-desc">
                                      <p class="testimonial-ttm-box-desc-p">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui 
                                        officia deserunt mollit anim laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantiumtam rem aperiam eaque ipsa quae inventore veritatis quasi architecto 
                                        beatae vitae.</p>
                                    </div>
                                    <div class="ttm-box-footer">
                                      <h3 class="testimonial-caption-h3">John Amanda</h3>
                                    </div>
                                  </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div class="testimonials-style1">
                                  <div class="testimonials-style1-content">
                                    <div class="testimonial-ttm-description">
                                      <div class="ttm-box-highlight">
                                        <h3 class="ttm-box-highlight-h3">Fast Support</h3>
                                      </div>
                                      <div class="ttm-ratting-stars">
                                        <ul class="ratting-stars">
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="testimonial-ttm-box-desc">
                                      <p class="testimonial-ttm-box-desc-p">Our team discussed every single detail to make sure Creatives Planet is the
                                      most versatile and unique template created so far. No coding skills.</p>
                                    </div>
                                    <div class="ttm-box-footer">
                                      <h3 class="testimonial-caption-h3">Aenna Bell</h3>
                                    </div>
                                  </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div class="testimonials-style1">
                                  <div class="testimonials-style1-content">
                                    <div class="testimonial-ttm-description">
                                      <div class="ttm-box-highlight">
                                        <h3 class="ttm-box-highlight-h3">Flexible Theme</h3>
                                      </div>
                                      <div class="ttm-ratting-stars">
                                        <ul class="ratting-stars">
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                          <li class="ratting-stars-items">
                                            <a href="#" class="ratting-stars-link"><i class="fa fa-star" aria-hidden="true"></i></a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="testimonial-ttm-box-desc">
                                    <p class="testimonial-ttm-box-desc-p">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui 
                                        officia deserunt mollit anim laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                        accusantium doloremque laudantiumtam rem aperiam eaque ipsa quae inventore veritatis quasi architecto 
                                        beatae vitae.</p>
                                    </div>
                                    <div class="ttm-box-footer">
                                      <h3 class="testimonial-caption-h3">Leon Mayer</h3>
                                    </div>
                                  </div>
                              </div>
                            </div>
                        </Slider>
                  </div>
                </div>
              </div>
            </section>

            <section class="ttm-row blog-section clearfix">
                <div class="container">
                  <div class="row align-items-center">
                      <div class="col-xl-8 col-lg-6 col-md-12 col-sm-12">
                          <div class="blog-title text-right">
                              <div class="section-title style2">
                                  <div class="title-header">
                                    <h2>Stay up</h2>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 "> 
                          <div class="process-desc process-desc1">
                              <p class="desc-text">Web designing in a powerful way of just not a profession, how in a passion for our Company. We have a to the idea.</p>
                          </div>
                      </div>
                  </div>
                  <div class="row align-items-center mt-25 res-991-mt-0">
                      <div class="col-xl-4 col-lg-3 col-md-12 col-sm-12 blog-sm">
                          <div class="blog-title text-right">
                              <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-gradiant res-991-mb-30" href={process.env.PUBLIC_URL + '/Blog'}>Upcoming News!</a>
                          </div>
                      </div>
                      <div class="col-xl-8 col-lg-9 col-md-12 col-sm-12 "> 
                          <div class="section-title style2">
                              <div class="title-header">
                                <h2>to date</h2>
                              </div>
                          </div>
                      </div>
                  </div>
                  <Slider className="row slick_slider" {...slick_slider} slidesToShow={3}arrows={false}
                    autoplay={false} responsive= { [{ breakpoint: 1199, settings: {slidesToShow: 3,slidesToScroll: 1 }},
                    {breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 }} ,
                    {breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 }},
                    {breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 }} ] }>
                      <div class="col-md-12">
                          <div class="featured-imagebox-post-style1">
                              <div class="featured-post-overlay">
                                  <div class="featured-post-thumbnail">
                                      <img class="img-fluid ttm-auto" src="images/blog/blog-01-828x894.png" loading="lazy" alt="image" />
                                  </div>
                                  <div class="featured-post-content">
                                      <div class="post-entry-date">10 Nov 2020</div>
                                      <div class="ttm-post-title">
                                        <h3 class="post-h3">
                                        <a href={process.env.PUBLIC_URL + '/Single_blog'} class="post-link">How Can I Manage IT Services in Business ?</a>
                                        </h3>
                                      </div>
                                      <div class="ttm-post-catagory">
                                        <div class="catagory-text">By John Doe</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="featured-imagebox-post-style1">
                              <div class="featured-post-overlay">
                                  <div class="featured-post-thumbnail">
                                      <img class="img-fluid ttm-auto" src="images/blog/blog-02-828x894.png" loading="lazy" alt="image" />
                                  </div>
                                  <div class="featured-post-content">
                                      <div class="post-entry-date">16 Feb 2020</div>
                                      <div class="ttm-post-title">
                                        <h3 class="post-h3">
                                        <a href={process.env.PUBLIC_URL + '/Single_blog'} class="post-link">Digital Conference Of IT Tech Events in 2019</a>
                                        </h3>
                                      </div>
                                      <div class="ttm-post-catagory">
                                        <div class="catagory-text">By John Doe</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-12">
                          <div class="featured-imagebox-post-style1">
                              <div class="featured-post-overlay">
                                  <div class="featured-post-thumbnail">
                                      <img class="img-fluid ttm-auto" src="images/blog/blog-03-828x894.jpg" loading="lazy" alt="image" />
                                  </div>
                                  <div class="featured-post-content">
                                      <div class="post-entry-date">01 Jan 2020</div>
                                      <div class="ttm-post-title">
                                        <h3 class="post-h3">
                                        <a href={process.env.PUBLIC_URL + '/Single_blog'} class="post-link">Where And How To Watch Live Stream Today</a>
                                        </h3>
                                      </div>
                                      <div class="ttm-post-catagory">
                                        <div class="catagory-text">By John Doe</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-12">
                        <div class="featured-imagebox-post-style1">
                            <div class="featured-post-overlay">
                                <div class="featured-post-thumbnail">
                                    <img class="img-fluid ttm-auto" src="images/blog/blog-04-828x894.png" loading="lazy" alt="image" />
                                </div>
                                <div class="featured-post-content">
                                    <div class="post-entry-date">22 Dec 2020</div>
                                    <div class="ttm-post-title">
                                      <h3 class="post-h3">
                                      <a href={process.env.PUBLIC_URL + '/Single_blog'} class="post-link">5 Easy Ways to Improve Your Web Security</a>
                                      </h3>
                                    </div>
                                    <div class="ttm-post-catagory">
                                      <div class="catagory-text">By John Doe</div>
                                    </div>
                                </div>
                            </div>
                          </div>
                      </div>
                  </Slider>
              </div>
            </section>

            <section class="ttm-row ttm-bg ttm-bgcolor-gradient client-section clearfix">
                <div class="container-fluid">
                    <Slider className="row slick_slider" {...slick_slider} slidesToShow={6}arrows={false}
                    autoplay={false} responsive= { [{ breakpoint: 1199, settings: {slidesToShow: 4,slidesToScroll: 2 }},
                    {breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 }} ,
                    {breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 }} ,
                    {breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 }} ,] }>
                      <div className="ttm-box-col-wrapper">
                        <div className="client-box">
                            <div className="client">
                                <div className="ttm-client">
                                    <img src="images/client/client-07.png" alt="" />
                                </div>
                            </div>
                        </div>
                      </div>
                      <div className="ttm-box-col-wrapper">
                        <div className="client-box">
                            <div className="client">
                                <div className="ttm-client">
                                    <img src="images/client/client-04.png" alt="" />
                                </div>
                            </div>
                        </div>
                      </div>
                      <div className="ttm-box-col-wrapper">
                        <div className="client-box">
                            <div className="client">
                                <div className="ttm-client">
                                    <img src="images/client/client-06.png" alt="" />
                                </div>
                            </div>
                        </div>
                      </div>
                      <div className="ttm-box-col-wrapper">
                        <div className="client-box">
                            <div className="client">
                                <div className="ttm-client">
                                    <img src="images/client/client-04.png" alt="" />
                                </div>
                            </div>
                        </div>
                      </div>
                      <div className="ttm-box-col-wrapper">
                        <div className="client-box">
                            <div className="client">
                                <div className="ttm-client">
                                    <img src="images/client/client-05.png" alt="" />
                                </div>
                            </div>
                        </div>
                      </div>
                      <div className="ttm-box-col-wrapper">
                        <div className="client-box">
                            <div className="client">
                                <div className="ttm-client">
                                    <img src="images/client/client-06.png" alt="" />
                                </div>
                            </div>
                        </div>
                      </div>
                      <div className="ttm-box-col-wrapper">
                        <div className="client-box">
                            <div className="client">
                                <div className="ttm-client">
                                    <img src="images/client/client-04.png" alt="" />
                                </div>
                            </div>
                        </div>
                      </div>
                    </Slider>
              </div>
            </section>

          </div>
        )
    }
}


export default Home;
